import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui";
import { PermissionGate } from "@/components/common";
import { Product } from "@/types";
import { Eye, MoreHorizontal, Pencil, Trash2 } from "lucide-react";

interface RowMenuProps {
  product: Product;
  onEdit: (product: Product) => void;
  onDelete: (product: Product) => void;
  onView: (id: string) => void;
}

export function ProductRowMenu({
  product,
  onEdit,
  onDelete,
  onView,
}: RowMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="shrink-0">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onView(product.id)}>
          <Eye className="mr-2 h-4 w-4" />
          View details
        </DropdownMenuItem>
        <PermissionGate permission="products.update">
          <DropdownMenuItem onClick={() => onEdit(product)}>
            <Pencil className="mr-2 h-4 w-4" />
            Edit
          </DropdownMenuItem>
        </PermissionGate>
        <PermissionGate permission="products.delete">
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            onClick={() => onDelete(product)}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Delete
          </DropdownMenuItem>
        </PermissionGate>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
